import { useState, useCallback } from "react";

export const useFriendsModal = () => {
  const [showFriendsModal, setShowFriendsModal] = useState(false);

  const openFriendsModal = useCallback(() => setShowFriendsModal(true), []);
  const closeFriendsModal = useCallback(() => setShowFriendsModal(false), []);

  return { showFriendsModal, openFriendsModal, closeFriendsModal };
};
